import fetch from '@/config/fetch';

export const
    // 供应商月考核-指标设置-START
    indicatorSettingsList = (data) => fetch('/platform/supplierMonthExamineManage/getModuleList', data, 'GET'),
    indicatorSettingsInfo = (id) => fetch(`/platform/supplierMonthExamineManage/getModuleDetailList/${id}`, {}, 'GET'),
    indicatorSettingsInfoAdd = (data) => fetch('/platform/supplierMonthExamineManage/add', data, 'POST'),
    indicatorSettingsInfoUpdate = (data) => fetch('/platform/supplierMonthExamineManage/updateModule', data, 'POST'),
    indicatorSettingsDelete = (id) => fetch(`/platform/supplierMonthExamineManage/deleteModule/${id}`, {}, 'POST'),
    indicatorSettingsGrading = (id) => fetch(`/platform/supplierMonthExamineManage/getScoringCriteriaList/${id}`, {}, 'GET'),
    // 供应商月考核-指标设置-END
    // 供应商月考核-月考核-START
    monthlyAssessmentList = (data) => fetch('/platform/supplierMonthExamineManage/getMonthExamineList', data, 'GET'),
    monthlyAssessmentInfo = (id) => fetch(`/platform/supplierMonthExamineManage/getMonthExamineDetail/${id}`, {}, 'GET'),
    monthlyAssessmentSubmit = (data) => fetch('/platform/supplierMonthExamineManage/submitMonthExamineDetail', data, 'POST'),
    monthlyAssessmentRefresh = () => fetch('/platform/supplierMonthExamineManage/supplierMonthExamineTask', {}, 'POST');
